(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  (function () {
    document.querySelectorAll('.cart-qty-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var idx   = this.dataset.index;
        var input = document.querySelector('.cart-qty-input[data-index="' + idx + '"]');
        var val   = parseInt(input.value, 10) || 0;
        if (this.dataset.action === 'plus') {
          input.value = val + 1;
        } else if (this.dataset.action === 'minus' && val > 0) {
          input.value = val - 1;
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderDrawer extends HTMLElement {
    connectedCallback() {
      this.hamburger = this.querySelector('.hamburger');
      this.drawer = this.querySelector('.drawer');
      this.overlay = this.querySelector('.drawer-overlay');
      this.closeBtn = this.querySelector('.drawer-close');

      this.hamburger.addEventListener('click', () => this.toggle());
      this.overlay.addEventListener('click', () => this.close());
      this.closeBtn.addEventListener('click', () => this.close());
      this.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') this.close();
      });

      this.querySelectorAll('.drawer-toggle').forEach((toggle) => {
        toggle.addEventListener('click', () => {
          const sub = toggle.nextElementSibling;
          const isOpen = toggle.getAttribute('aria-expanded') === 'true';
          toggle.setAttribute('aria-expanded', String(!isOpen));
          sub.hidden = isOpen;
        });
      });
    }

    toggle() {
      this.drawer.classList.contains('is-open') ? this.close() : this.open();
    }

    open() {
      this.drawer.classList.add('is-open');
      this.drawer.setAttribute('aria-hidden', 'false');
      this.hamburger.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }

    close() {
      this.drawer.classList.remove('is-open');
      this.drawer.setAttribute('aria-hidden', 'true');
      this.hamburger.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }
  }

  customElements.define('header-drawer', HeaderDrawer);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-banner"] && !Shopify.designMode) return;
  try {
    
  class HeroSlideshow extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('.hero-banner-slide'));
      this.dots = Array.from(this.querySelectorAll('.hero-banner-dot'));
      this.current = 0;

      if (this.slides.length <= 1) return;

      this.dots.forEach((dot, index) => {
        dot.addEventListener('click', () => this.goTo(index));
      });

      this.addEventListener('mouseenter', () => this.pause());
      this.addEventListener('mouseleave', () => this.resume());

      this.resume();
    }

    goTo(index) {
      this.slides[this.current].classList.remove('is-active');
      if (this.dots[this.current]) this.dots[this.current].classList.remove('is-active');
      this.current = index;
      this.slides[this.current].classList.add('is-active');
      if (this.dots[this.current]) this.dots[this.current].classList.add('is-active');
    }

    next() {
      this.goTo((this.current + 1) % this.slides.length);
    }

    pause() {
      clearInterval(this.interval);
    }

    resume() {
      var delay = parseInt(this.dataset.autoplay, 10) || 5000;
      this.interval = setInterval(() => this.next(), delay);
    }

    disconnectedCallback() {
      clearInterval(this.interval);
    }
  }

  customElements.define('hero-slideshow', HeroSlideshow);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  class ProductGallery extends HTMLElement {
    connectedCallback() {
      this.items = Array.from(this.querySelectorAll('.product-gallery-main-item'));
      this.thumbs = Array.from(this.querySelectorAll('.product-gallery-thumb'));
      this.thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => this.goTo(thumb.dataset.index));
      });
    }

    goTo(index) {
      this.items.forEach((item) => item.classList.toggle('is-active', item.dataset.index === index));
      this.thumbs.forEach((thumb) => thumb.classList.toggle('is-active', thumb.dataset.index === index));
    }
  }
  customElements.define('product-gallery', ProductGallery);

  class ProductInfo extends HTMLElement {
    connectedCallback() {
      const variantsJson = this.querySelector('[data-product-variants-json]');
      this.variants = variantsJson ? JSON.parse(variantsJson.textContent) : [];
      this.variantIdInput = this.querySelector('[data-variant-id]');
      this.priceAmount = this.querySelector('[data-price-amount]');
      this.addToCartButton = this.querySelector('[data-add-to-cart]');
      this.addToCartLabel = this.querySelector('[data-add-to-cart-label]');
      this.optionGroups = Array.from(this.querySelectorAll('[data-option-values]'));

      this.optionGroups.forEach((group) => {
        group.querySelectorAll('[data-option-index]').forEach((button) => {
          button.addEventListener('click', () => this.selectOption(group, button));
        });
      });

      const quantityInput = this.querySelector('[data-quantity-input]');
      this.querySelector('[data-quantity-decrease]')?.addEventListener('click', () => {
        quantityInput.value = Math.max(1, (parseInt(quantityInput.value, 10) || 1) - 1);
      });
      this.querySelector('[data-quantity-increase]')?.addEventListener('click', () => {
        quantityInput.value = (parseInt(quantityInput.value, 10) || 1) + 1;
      });

      this.updateAvailability();
    }

    selectOption(group, button) {
      group.querySelectorAll('[data-option-index]').forEach((b) => b.classList.remove('is-selected'));
      button.classList.add('is-selected');
      this.updateVariant();
    }

    getSelectedOptions() {
      return this.optionGroups.map((group) => {
        const selected = group.querySelector('.is-selected');
        return selected ? selected.dataset.value : null;
      });
    }

    findVariant(selected) {
      return this.variants.find((variant) =>
        selected.every((value, index) => value === null || variant.options[index] === value)
      );
    }

    updateVariant() {
      const selected = this.getSelectedOptions();
      const matched = this.findVariant(selected);
      this.updateAvailability();

      if (!matched) {
        this.addToCartButton.disabled = true;
        if (this.addToCartLabel) this.addToCartLabel.textContent = this.addToCartButton.dataset.labelSoldOut;
        return;
      }

      this.variantIdInput.value = matched.id;
      if (this.priceAmount) this.priceAmount.innerHTML = this.renderPrice(matched);
      this.addToCartButton.disabled = !matched.available;
      if (this.addToCartLabel) {
        this.addToCartLabel.textContent = matched.available
          ? this.addToCartButton.dataset.labelAvailable
          : this.addToCartButton.dataset.labelSoldOut;
      }
    }

    updateAvailability() {
      if (!this.optionGroups.length) return;
      const selected = this.getSelectedOptions();
      this.optionGroups.forEach((group) => {
        group.querySelectorAll('[data-option-index]').forEach((button) => {
          const index = parseInt(button.dataset.optionIndex, 10);
          const testSelection = selected.slice();
          testSelection[index] = button.dataset.value;
          const available = this.variants.some(
            (variant) =>
              variant.available &&
              testSelection.every((value, i) => value === null || variant.options[i] === value)
          );
          button.classList.toggle('is-unavailable', !available);
        });
      });
    }

    renderPrice(variant) {
      const format = (cents) => '¥' + Math.round(cents / 100).toLocaleString('ja-JP');
      if (variant.compare_at_price && Number(variant.compare_at_price) > Number(variant.price)) {
        return (
          '<span class="product-price-sale">' + format(variant.price) + '</span>' +
          '<span class="product-price-compare">' + format(variant.compare_at_price) + '</span>'
        );
      }
      return '<span class="product-price-regular">' + format(variant.price) + '</span>';
    }
  }
  customElements.define('product-info', ProductInfo);

  class ProductRecommendations extends HTMLElement {
    connectedCallback() {
      const url = this.dataset.url;
      if (!url) return;

      fetch(url)
        .then((response) => response.text())
        .then((text) => {
          const wrapper = document.createElement('div');
          wrapper.innerHTML = text;
          const content = wrapper.querySelector('[data-product-recommendations-content]');
          if (content && content.innerHTML.trim().length) {
            this.innerHTML = content.outerHTML;
          } else {
            this.remove();
          }
        })
        .catch(() => this.remove());
    }
  }
  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
